export const SET_LEAD = '[LEAD] SET LEAD';
export const REMOVE_LEAD = '[LEAD] REMOVE LEAD';

export function setLead(value)
{
    return {
        type: SET_LEAD,
        payload: value
    };
}

export function removeLead()
{
    return {
        type: REMOVE_LEAD
    }
}

